import tailwindConfig from '../../tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'
import { Config } from 'tailwindcss/types/config'

const fullConfig = resolveConfig(tailwindConfig as unknown as Config)

const colors = fullConfig.theme.colors as unknown as {
    [key: string]: Record<string, string> | string
}

/** Replace the Tailwind alpha placeholder with a concrete opacity of 1. */
export const parseColor = (colorStr: string): string => {
    return colorStr.replace('<alpha-value>', '1')
}

export const getTailwindColor = (name: string, shade?: string): string => {
    const entry = colors[name]

    if (shade !== undefined) {
        if (typeof entry === 'string') {
            return parseColor(entry)
        }
        return parseColor(entry[shade])
    }

    if (typeof entry === 'string') {
        return parseColor(entry)
    }

    return parseColor(entry.DEFAULT)
}
